module.exports = __webpack_public_path__ + "static/media/df (5).daa0fcb9.jpg";